<div class="flex pt-2 justify-content-between align-items-center" appManageValidatorDisplay [control]="formControl">
  <span>{{ props.label }}</span>

  <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
</div>

@if (props.options$.asObservable() | async; as options) {
  @for (option of options; track option) {
    <cap-checkbox [label]="option[props.label_key]" (checkboxChange)="setChecked(option, $event.checked)">
    </cap-checkbox>
  }
}
